/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_DomainsInputs */

const id_portal_nav_domains = /** @type {(inputs: Portal_Nav_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain`)
};

const en_portal_nav_domains = /** @type {(inputs: Portal_Nav_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domains`)
};

/**
* | output |
* | --- |
* | "Domains" |
*
* @param {Portal_Nav_DomainsInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_nav_domains = /** @type {((inputs?: Portal_Nav_DomainsInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_DomainsInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_nav_domains(inputs)
	return id_portal_nav_domains(inputs)
});